import { ShippingRestrictions } from '@adapters/bigcommerce/types/product';
import shipperhqRates from '../../shipperhq-rates.json';
import { transformShippingOptions } from './transformShippingOptions';
import { ShipperHQRates } from '@adapters/bigcommerce/types/shipping';
import { RESTRICTION_LEVELS } from './constants';

const shipperhqRatesTyped = (shipperhqRates as unknown as ShipperHQRates) || {};

export const getPDPShippingOptions = (
  shippingRestrictions: ShippingRestrictions,
  locale: string
) => {
  if (
    shippingRestrictions?.restriction_level === RESTRICTION_LEVELS.BIKE_ONLY
  ) {
    const bikeOnlyRates = shipperhqRatesTyped.allRates.bike_only;
    return transformShippingOptions(locale, true, bikeOnlyRates);
  }
  if (
    shippingRestrictions?.restriction_level ===
      RESTRICTION_LEVELS.OVER_SIZE_R5 ||
    shippingRestrictions?.restriction_level === RESTRICTION_LEVELS.OVER_SIZE_R2
  ) {
    const overSizeSurchargeRates =
      shipperhqRatesTyped.allRates.over_size_surcharge;
    return transformShippingOptions(locale, false, overSizeSurchargeRates);
  }
  const defaultRates = shipperhqRatesTyped.allRates.regular;
  return transformShippingOptions(locale, false, defaultRates);
};
